import { ContentItem, Fields, IContentItem } from 'kentico-cloud-delivery-typescript-sdk';

/**
 * This class was generated by 'kentico-cloud-model-generator-utility' module.
 * You can substitute instances of 'IContentItem' with a model defined in other class
 * to get access to all properties. This is applicable only if you know what item type the field contains.
 */
export class Project extends ContentItem {
    public slug: Fields.UrlSlugField;
    public date: Fields.DateTimeField;
    public coverImage: Fields.AssetsField;
    public title: Fields.TextField;
    public slogan: Fields.TextField;
    public tags: Fields.TaxonomyField;
    public overview: Fields.RichTextField;
    public theChallenge: Fields.RichTextField;
    public theOutcome: Fields.RichTextField;
    public story: IContentItem[];
    
    constructor(){
        super({
            propertyResolver: ((fieldName: string) => {
                
                if (fieldName === 'cover_image'){
                    return 'coverImage';
                }

                if (fieldName === 'the_challenge'){
                    return 'theChallenge';
                }

                if (fieldName === 'the_outcome'){
                    return 'theOutcome';
                }

                return fieldName;
            })
        })    
    }
    
}


// WEBPACK FOOTER //
// /opt/build/repo/src/app/models/project.ts